import React from "react";
import Icon from "../media/footer-logo.png";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";

import Project1 from "../media/news-4.jpeg";
import Project2 from "../media/news-2.jpeg";

function Footer() {
  return (
    <div className="bg-[#2E5233] h-[500px] pt-16 text-white relative">
      <div className="md:container md:mx-auto sm:mx-16 flex md:justify-between sm:justify-center sm:text-sm">
        <div className="footer_social flex flex-col gap-y-10">
          <div className="logo sm:flex sm:justify-center">
            <a href="/">
              <img src={Icon} alt="logo" />
            </a>
          </div>
          <p className="text-sm md:w-52 sm:w-full sm:text-center md:text-start">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta
            expedita at nihil excepturi totam? Vero,
          </p>
          <div className="social flex md:gap-x-5 sm:gap-x-10 text-lg">
            <a
              className="border p-3 rounded-lg transition-all ease-in-out delay-150 hover:bg-white hover:text-second"
              href="https://www.facebook.com/Zaferoglu-%C4%B0n%C5%9Faat-136901673641060"
            >
              <FaFacebookF />
            </a>
            <a
              className="border p-3 rounded-lg  transition-all ease-in-out delay-150 hover:bg-white hover:text-second"
              href="https://www.instagram.com/zaferoglu_inshaat/"
            >
              <FaInstagram />
            </a>
            <a
              className="border p-3 rounded-lg  transition-all ease-in-out delay-150 hover:bg-white hover:text-second"
              href="https://www.linkedin.com/company/zaferoglu-inshaat/"
            >
              <FaLinkedinIn />
            </a>
            <a
              className="border p-3 rounded-lg  transition-all ease-in-out delay-150 hover:bg-white hover:text-second"
              href="https://wa.me/+994517111111"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <div className="site_map md:flex sm:hidden flex-col gap-y-16 mr-10">
          <h1 className="text-2xl ml-7 ">Saytın xəritəsi</h1>
          <nav>
            <ul className="grid grid-cols-2 gap-3 text-sm">
              <li className="order-1">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Ana səhifə
                </NavLink>
              </li>
              <li className="order-3">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/haqqimizda"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Haqqımızda
                </NavLink>
              </li>
              <li className="order-5">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/layiheler"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Layihələr
                </NavLink>
              </li>
              <li className="order-7">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/xidmetler"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Xidmətlər
                </NavLink>
              </li>
              <li className="order-2">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/vakansiyalar"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Vakansiyalar
                </NavLink>
              </li>
              <li className="order-4">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/xeberler"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Xəbərlər
                </NavLink>
              </li>
              <li className="order-6">
                <NavLink
                  className="px-2 py-1 rounded-2xl flex"
                  style={({ isActive }) => ({
                    color: isActive ? "lime" : "white",
                    transition: ".4s all ease",
                  })}
                  to="/elaqe"
                >
                  <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
                  Əlaqə
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>

        <div className="last_projects sm:hidden md:flex flex-col gap-y-16">
          <h1 className="text-2xl">Son layihələr</h1>
          <div className="projects grid grid-cols-4 gap-2">
            <a href="#">
              <img className="w-20 h-20" src={Project1} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project2} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project1} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project2} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project1} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project2} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project1} alt="" />
            </a>
            <a href="#">
              <img className="w-20 h-20" src={Project2} alt="" />
            </a>
          </div>
        </div>
      </div>
      <div className="absolute left-[13%] mt-16 border-t-2 border-gray-500 w-[75%] flex justify-between sm:text-sm">
        <p className="mt-10">© 2022 Archbaku.az. </p>
        <p className="mt-10">Site by Ismailoff</p>
      </div>
    </div>
  );
}

export default Footer;
